import React from 'react';
import { Box, Container, Grid, Typography, Card, CardContent, CardMedia } from '@mui/material';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Fleet = () => {
  const { t } = useTranslation();

  const vehicles = [
    {
      title: 'Mercedes-Benz S-Class',
      description: t('fleet.sclass.description', 'Lüks ve konforun zirvesi. 3 yolcu kapasiteli VIP sedan.'),
      image: '/images/s-class.webp',
      specs: [
        `3 ${t('fleet.specs.passengers')}`,
        t('fleet.specs.leather'),
        t('fleet.specs.climate'),
        t('fleet.specs.wifi')
      ],
      delay: 0.2,
    },
    {
      title: 'Mercedes-Benz V-Class',
      description: t('fleet.vclass.description', 'Geniş gruplar için lüks ve konforlu VIP van.'),
      image: '/images/v-class.webp',
      specs: [
        `7 ${t('fleet.specs.passengers')}`,
        t('fleet.specs.leather'),
        t('fleet.specs.climate'),
        t('fleet.specs.wifi')
      ],
      delay: 0.4,
    },
    {
      title: 'BMW 7 Series',
      description: t('fleet.bmw7.description', 'Premium konfor ve teknoloji bir arada.'),
      image: '/images/bmw-7.webp',
      specs: [
        `3 ${t('fleet.specs.passengers')}`,
        t('fleet.specs.leather'),
        t('fleet.specs.climate'),
        t('fleet.specs.wifi')
      ],
      delay: 0.6,
    },
  ];

  return (
    <Box
      id="fleet"
      sx={{
        py: 8,
        backgroundColor: 'background.default',
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Typography
            variant="h2"
            align="center"
            sx={{
              mb: 6,
              fontWeight: 700,
              color: 'primary.main',
            }}
          >
            {t('fleet.title')}
          </Typography>
        </motion.div>

        <Grid container spacing={4}>
          {vehicles.map((vehicle, index) => (
            <Grid item xs={12} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: vehicle.delay }}
              >
                <Card
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    '&:hover': {
                      transform: 'scale(1.02)',
                      transition: 'transform 0.3s ease-in-out',
                    },
                  }}
                >
                  <CardMedia
                    component="img"
                    height="240"
                    image={vehicle.image}
                    alt={vehicle.title}
                    sx={{
                      objectFit: 'cover',
                    }}
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography gutterBottom variant="h5" component="h3" sx={{ fontWeight: 600 }}>
                      {vehicle.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary" paragraph>
                      {vehicle.description}
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2 }}>
                      {vehicle.specs.map((spec, i) => (
                        <Typography
                          key={i}
                          variant="body2"
                          sx={{
                            backgroundColor: 'secondary.main',
                            color: 'white',
                            px: 2,
                            py: 0.5,
                            borderRadius: 1,
                          }}
                        >
                          {spec}
                        </Typography>
                      ))}
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Fleet; 